<template>
  <div class="d-flex align-items-center size-tag">
    <div class="size-info">
      <div class="size-label">
        <label>{{ name }}</label>
      </div>
      <div class="size-value">
        <label>{{ displaySize }}</label>
      </div>
    </div>
    <div class="delete-button">
      <div
          v-if="isFavourite"
          class="hover-delete-icon hover-icon"
          @mousedown="deleteFavouriteSizeOfProduct($event,id)">
        <icon :name="'trash'"/>
      </div>
    </div>


  </div>
</template>

<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:  'Size',
  props: {
    id:          String,
    name:        String,
    size:        String,
    unit:        String,
    isFavourite: Boolean,
  },
  computed: {
    displaySize() {
      const size = this.size.replace(/"/g, '').replace(/\s*x\s*/, ' × ');
      return `${size} ${this.unit === 'Inches' ? 'in' : 'px'}`;
    },
  },
  methods: {
    deleteFavouriteSizeOfProduct(event, id) {
      EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
        request: 'deleteFavouriteSizeFromAPI',
        data:    {
          id,
        },
        message: 'Are you sure you want to delete this canvas size from your favorites?',
      });
      event.stopPropagation();
    },
  },

};
</script>

<style scoped  lang="scss">
.size-tag{
  padding: 8px 12px;
  gap: 8px;
  label{
    cursor: pointer;
    font-size: 12.5px;
    color: $grey90;
  }
  .size-info{
    flex: 1 1 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .size-label{
      word-break: break-word;
    }
    .size-value label{
      font-family: 'Geist Mono', ui-monospace, Menlo, Consolas, monospace !important;
      color: $grey60;
      white-space: nowrap;
    }
  }
  .delete-button{
    display: flex;
  }
}
</style>
